<div id="generic-banner" class="card hca-member-warning-card" style="padding: 15px" *ngIf="show">
    <div fxLayout="column" fxLayoutAlign="center center" class="fxGap-medium">
        <div fxLayout="row" fxLayoutAlign="center center">
          <fa-icon style="margin-right: 15px;" [icon]="icons.faWarning" size="2x"></fa-icon>
          <h4 style="font-weight: bold" class="card-title">{{title}}</h4>
        </div>
        <p id="banner-text" class="card-text" [innerHtml]="textInnerHTML">
        </p>
    </div>
</div>